import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeCl from '@angular/common/locales/es-CL';
import localeMx from '@angular/common/locales/es-MX';
import localePtBR from '@angular/common/locales/pt';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
} from '@ngx-translate/core';
import isString from 'lodash-es/isString';
import merge from 'lodash-es/merge';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LOCALES } from '../models/main';

// Magia arcana para meter el puto espacio entre el ISO code y el valor numerico
// @ts-ignore
localeEn[14][2] = '¤ #,##0.00';
// @ts-ignore
localeCl[14][2] = '¤ #,##0.00';

// registerLocaleData(module) registers under the locale ID embedded in the module data, which can
// differ from the locale string you need. Always pass the explicit ID as second arg when they differ.
// Example: @angular/common/locales/pt has internal id 'pt' (Portugal), not 'pt-BR'. Since Angular 16
// does not ship a separate locales/pt-BR module, Brazilian Portuguese requires the explicit second arg:
// registerLocaleData(localePtBR, 'pt-BR').
// If a future Angular upgrade adds locales/pt-BR, prefer that import and drop the second arg.
registerLocaleData(localeEs);
registerLocaleData(localeEn);
registerLocaleData(localeCl);
registerLocaleData(localeMx);
registerLocaleData(localePtBR, 'pt-BR');

export class HttpCustomLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(locale: LOCALES): Observable<any> {
    const usesEsFallback = locale === LOCALES.CL || locale === LOCALES.MX;
    const requests = [
      this.http.get(`/assets/i18n/common/${locale}.json`),
      this.http.get(`/assets/i18n/${locale}.json`),
    ];

    if (usesEsFallback) {
      requests.push(this.http.get(`/assets/i18n/common/${LOCALES.ES}.json`));
      requests.push(this.http.get(`/assets/i18n/${LOCALES.ES}.json`));
    }

    return forkJoin(requests).pipe(
      map((res) => {
        const localeTranslations = merge(res[0], res[1]);
        if (!usesEsFallback) return localeTranslations;
        const esTranslations = merge(res[2], res[3]);
        return merge(esTranslations, localeTranslations);
      }),
    );
  }
}

export const compareI18N = (
  esObject: any,
  enObject: any,
  path: string,
): { equals: boolean; reason: string } => {
  const esKeys = Object.keys(esObject);
  const enKeys = Object.keys(enObject);
  if (esKeys.length !== enKeys.length) {
    return {
      equals: false,
      reason: `Not same number of keys in ${path} - ${esKeys} vs ${path} - ${enKeys}`,
    };
  }
  for (let i = 0; i < esKeys.length; i++) {
    if (esKeys[i] !== enKeys[i]) {
      return {
        equals: false,
        reason: `Not same value in position ${i}: ${path} - ${esKeys[i]} !== ${path} - ${enKeys[i]}`,
      };
    }
    if (!isString(esObject[esKeys[i]])) {
      const res = compareI18N(
        esObject[esKeys[i]],
        enObject[enKeys[i]],
        path + ' - ' + esKeys[i],
      );
      if (!res.equals) return res;
    }
  }
  return { equals: true, reason: '' };
};

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    console.error('Valor i18n no encontrado: ' + params.key);
    return params.key;
  }
}
